import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, map, pluck, tap } from 'rxjs/operators';
import { CookieManagementService } from 'src/app/account/services/cookie-management.service';
import { AppConfig } from 'src/app/config-service/app.config';
import { VersionHelper } from 'src/app/utility-packages/versionHelper/version-helper';
import { DefinedCardPaymentInfo, SaveCardPaymentInfo, TransactionRequestCardOpTypes, TransactionRequestPaymentModels } from '../../models/transaction-request-models';
import { getBodyCreator } from './utility-classes/transaction-request-body';
import { TransactionRequestResponseCreator } from './utility-classes/transaction-request-response';

@Injectable({
  providedIn: 'root'
})
export class TranscationRequestService {

  constructor(
    private http:HttpClient,
    private cookieManagementService:CookieManagementService,
    private versionHelper: VersionHelper,
    private translate: TranslateService,
    private toastr: ToastrService
  ){ }

  private accessToken = '';

  TransactionRequest<T, K extends TransactionRequestPaymentModels>(card_ops_type: TransactionRequestCardOpTypes, params?:T) 
    : Observable<K>
  {
    const bodyCreator = getBodyCreator(card_ops_type);
    const responseCreator = new TransactionRequestResponseCreator(
      this.http,
      this.versionHelper,
      this.translate,
      this.toastr
    )

    this.accessToken = this.cookieManagementService.getAccessToken();
    if (this.accessToken == '') {
      return new Observable();
    } else {
      const headers:HttpHeaders = this.setHeaders(this.accessToken); 
      const body:URLSearchParams = bodyCreator.setBody(params);
      
      return responseCreator.createResponseReturnPaymentInfo(headers, body)
      .pipe(
        map(resp => resp as K)
      );

    };

  }

  private setHeaders = (accessToken:string) : HttpHeaders => {
    accessToken = 'Bearer ' + accessToken;

    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: accessToken,
    });
  }

}
